import {createAction, props} from '@ngrx/store';

export const clickedButton = createAction(
  '[Button Component] Clicked button',
  props<{ payload: { title: string; targetUrl: string; actionGroupId: string; data?: {[key: string]: any} } }>()
);
